(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["babyskincare-banner"] && !window.DesignMode) return;
  try {
    
$(window).on("load", function () {
  $(".babyskincare-banner .dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".babyskincare-new-arrivals").offset().top + 100 
    }, 500);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babyskincare-ingredients"] && !window.DesignMode) return;
  try {
    
$(window).on('load', function() {
  if ($(window).width() < 768) {
   const m_slider = $(".ingredient-main");
    m_slider.slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1
    }); 
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babyskincare-new-arrivals"] && !window.DesignMode) return;
  try {
    
$(window).on('load', function() {
   const m_slider = $(".bsc-main .skincare-product-block");
    m_slider.slick({
      dots: false,
      arrows: true, 
      infinite: false,
      speed: 800,
      slidesToShow: 4,
      slidesToScroll: 1,
        responsive: [
      {
        breakpoint: 1025, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    }); 
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babyskincare-slider"] && !window.DesignMode) return;
  try {
    

$(window).on('load', function() {
   const m_slider = $(".babyskincare-slider-main");
    m_slider.slick({
      dots: true,
      arrows: true, 
      infinite: false,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1
    });
}); 
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babyskincare-vertical-scroll-slider"] && !window.DesignMode) return;
  try {
    
    
  $(window).load(function() {
  // wait for document ready

  // init
  var controller = new ScrollMagic.Controller();

  // define movement of panels
  var wipeAnimation = new TimelineMax()
    .to(".panel.one", 1, { x: "-100%", ease: Linear.easeNone })
    .to(".panel.two", 1, { x: "-100%", ease: Linear.easeNone })
    .to(".panel.three", 1, { x: "-100%", ease: Linear.easeNone })
    .to(".panel.four", 1, { x: "-100%", ease: Linear.easeNone })
    .to(".panel.five", 1, { x: "-100%", ease: Linear.easeNone });

  // create scene to pin and link animation
  new ScrollMagic.Scene({
    triggerElement: ".pinContainer",
    triggerHook: "onLeave",
    duration: "800%" 
  })
    .setPin(".pinContainer")
    .setTween(wipeAnimation)
    //.addIndicators() add indicators (requires plugin)
    .addTo(controller);
}); 
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["backtoschool-banner"] && !window.DesignMode) return;
  try {
    
$(window).on("load", function () {
  $(".backtoschool-banner .dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".backtoschool-new-arrivals").offset().top + 100 
    }, 500);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["backtoschool-new-arrivals"] && !window.DesignMode) return;
  try {
    
$(window).on('load', function() {
   const m_slider = $(".bsc-main .skincare-product-block");
    m_slider.slick({
      dots: false,
      arrows: true, 
      infinite: false,
      speed: 800,
      slidesToShow: 4,
      slidesToScroll: 1,
        responsive: [
      {
        breakpoint: 1025, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    }); 
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-slider-2"]) return;
  try {
    
  $(window).on('load', function() {
     const m_slider = $(".cat-slick-main .category-product-block");
      m_slider.slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
          responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 525,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-slider"]) return;
  try {
    
  $(window).on('load', function() {
   const m_slider = $(".product-slick-slider");
    m_slider.slick({
      dots: false,
      arrows: true, 
      infinite: false,
      speed: 800,
      slidesToShow: `{{ slides }}`,
      slidesToScroll: 1,
        responsive: [
      {
        breakpoint: 1096, 
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    }); 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cell-salts_collection-slider"]) return;
  try {
    
$(window).on('load', function() {
   const m_slider = $(".cat-slick-main .featured-product-block");
    m_slider.slick({
      dots: false,
      arrows: true, 
      infinite: false,
      speed: 800,
      slidesToShow: 4,
      slidesToScroll: 1,
        responsive: [
      {
        breakpoint: 1025, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 525,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    }); 
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chafing-banner"] && !window.DesignMode) return;
  try {
    
$(window).on("load", function () {
  $(".chafing-banner .dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".chafing-new-arrivals").offset().top + 100 
    }, 500);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chafing-new-arrivals"] && !window.DesignMode) return;
  try {
    
$(window).on('load', function() {
   const m_slider = $(".bsc-main .skincare-product-block");
    m_slider.slick({
      dots: false,
      arrows: true, 
      infinite: false,
      speed: 800,
      slidesToShow: 4,
      slidesToScroll: 1,
        responsive: [
      {
        breakpoint: 1025, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    }); 
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chafing-second-block"] && !window.DesignMode) return;
  try {
    
$(window).on("load", function () {
  $(".chafing-banner .dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".chafing-new-arrivals").offset().top + 100 
    }, 500);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chafing-slider"] && !window.DesignMode) return;
  try {
    

$(window).on('load', function() {
   const m_slider = $(".chafing-slider-main");
    m_slider.slick({
      dots: true,
      arrows: true, 
      infinite: false,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1
    });
}); 
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chafing-third-block"] && !window.DesignMode) return;
  try {
    
$(window).on("load", function () {
  $(".chafing-banner .dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".chafing-new-arrivals").offset().top + 100 
    }, 500);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cold-cough-banner"] && !window.DesignMode) return;
  try {
    
$(window).on("load", function () {
  $(".cold-cough-banner .dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".cold-cough-new-arrivals").offset().top + 100 
    }, 500);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cold-cough-new-arrivals"] && !window.DesignMode) return;
  try {
    
$(window).on('load', function() {
   const m_slider = $(".bsc-main .cold-cough-product-block");
    m_slider.slick({
      dots: false,
      arrows: true, 
      infinite: false,
      speed: 800,
      slidesToShow: 4,
      slidesToScroll: 1,
        responsive: [
      {
        breakpoint: 1025, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    }); 
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cold-cough-slider"] && !window.DesignMode) return;
  try {
    


$(window).on('load', function() {
   const m_slider = $(".cold-cough-slider-main");
    m_slider.slick({
      dots: true,
      arrows: true, 
      infinite: false,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1
    });
}); 
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dogs-banner"] && !window.DesignMode) return;
  try {
    
$(window).on("load", function () {
  $(".dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".dogs-best-sellers").offset().top + 200 
    }, 500);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dogs-horizon-scroll-slider"] && !window.DesignMode) return;
  try {
    
  
  var controller = new ScrollMagic.Controller();

$(function () {
  //var tween = TweenMax.to(".block-list", 1, {className: "+=scrollend"});
  
  var $block_list = $('.block-list'),
      $block_item = $block_list.find('.block-list__item'),
      block_list_width = $block_list.outerWidth(),
      block_item_width = $block_item.outerWidth(),
      total_width = block_item_width * $block_item.length,
      travel_distance = total_width - block_list_width + 20;

  var scene = new ScrollMagic.Scene({
    triggerElement: "#second",
    duration: '10650',
    triggerHook: 0
  })
  .setPin('.block-list')  
  //.setTween(tween)
  .addTo(controller);
   
  scene.on('progress', function(e) {
    var progress = e.progress,
        move = -travel_distance * progress + "px";
    $block_list.css({
      transform: "translateX(" + move + ")"
    });
  });

  scene.on('update',function(event){
		console.log(event.scrollPos);
  });
  
    $(document).on("click", "#scrollNext", function(){
      if($(".block-list__item.active").next().length > 0) {
        let elem = $(".block-list__item.active").next();
        let id = "#block-list__item-"+$(".block-list__item.active").next().data("index");
        
        controller.scrollTo(id);
      }
    });

  if ($(".dogs-horizon-scroll").length > 0) {
    if ($(window).width() < 768) {
      $(".dogs-horizon-scroll .block-list-mobile").slick({
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  } 
/*
$('#scrollNext').click(function(){
        $('.block-list__item.active').animate({
            width: "100%"
        });
});
*/

const $slidesContainer = $(".block-list.desktop");
const $slides = $slidesContainer.children(".block-list__item");
const $btnPrev = $("#scrollPrev");
const $btnNext = $("#scrollNext");
  

const imgWidth = $slides.first().width();
let isSlideAnimating = false;

// Position all the slides next to each other...
$slides.each(function (i) {
  const leftPos = i * imgWidth;

  $(this).css("left", leftPos);
});

// Move the last slide in front of the first slide
// in case the user pushes the "prev" button...
$slides.last().prependTo($slidesContainer).css("left", -imgWidth);

$btnPrev.click(prevSlide);
$btnNext.click(nextSlide);

function prevSlide() {
  if (isSlideAnimating) {
    return;
  }

  isSlideAnimating = true;

  $slidesContainer
    .children()
    .last()
    .css("left", -(imgWidth * 2))
    .prependTo($slidesContainer);

  $slides.animate({ left: "+=" + imgWidth }, 300, function () {
    isSlideAnimating = false;
  });
}

function nextSlide() {
  if (isSlideAnimating) {
    return;
  }

  isSlideAnimating = true;

  $slidesContainer
    .children()
    .first()
    .css("left", imgWidth * ($slides.length - 1))
    .appendTo($slidesContainer);

  $slides.animate({ left: "-=" + imgWidth }, 300, function () {
    isSlideAnimating = false;
  });
}


}); 

$(document).ready(function() {
  var s = $(".dogs-horizon-scroll");
  var pos = s.position();
  $(window).scroll(function() {
      var windowpos = $(window).scrollTop();
      if (windowpos <=15060) {
        s.removeClass("btn-stick");
          
      } else {
        s.addClass("btn-stick");
      }
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dogs-vertical-scroll-slider"] && !window.DesignMode) return;
  try {
    
  /* window.addEventListener("DOMContentLoaded", ()=>{
    $(window).load(function() {
    // wait for document ready
    // init
    var controller = new ScrollMagic.Controller();

    // define movement of panels
    var wipeAnimation = new TimelineMax()
      .to(".panel.one", 1, { x: "-100%", ease: Linear.easeNone })
      .to(".panel.two", 1, { x: "-100%", ease: Linear.easeNone })
      .to(".panel.three", 1, { x: "-100%", ease: Linear.easeNone })
      .to(".panel.four", 1, { x: "-100%", ease: Linear.easeNone });
      //.to(".panel.five", 1, { x: "-100%", ease: Linear.easeNone });

    // create scene to pin and link animation
    new ScrollMagic.Scene({
      triggerElement: ".pinContainer",
      triggerHook: "onLeave",
      duration: "800%"
    })
      .setPin(".pinContainer")
      .setTween(wipeAnimation)
      //.addIndicators() add indicators (requires plugin)
      .addTo(controller);
    });
  }) */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ears-banner"] && !window.DesignMode) return;
  try {
    
$(window).on("load", function () {
  $(".ears-banner .dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".ears-new-arrivals").offset().top + 100 
    }, 500);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ears-double-image-1"] && !window.DesignMode) return;
  try {
    
$(window).on("load", function () {
  $(".chafing-banner .dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".chafing-new-arrivals").offset().top + 100 
    }, 500);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ears-double-image-2"] && !window.DesignMode) return;
  try {
    
$(window).on("load", function () {
  $(".chafing-banner .dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".chafing-new-arrivals").offset().top + 100 
    }, 500);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ears-no1-product"] && !window.DesignMode) return;
  try {
    
$(window).on("load", function () {
  $(".ears-banner .dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".ears-new-arrivals").offset().top + 100 
    }, 500);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["general_product-slider"]) return;
  try {
    
$(window).on('load', function() {
   const m_slider = $(".cat-slick-main .featured-product-block");
    m_slider.slick({
      dots: false,
      arrows: true, 
      infinite: false,
      speed: 800,
      slidesToShow: 4,
      slidesToScroll: 1,
        responsive: [
      {
        breakpoint: 1025, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 525,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    }); 
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["general_two-column-banner-w-image"] && !window.DesignMode) return;
  try {
    

$(window).on("load", function () {
  $(".gen-2col-banner .dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".gen-2col-new-arrivals").offset().top + 100 
    }, 500);
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-slider"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", (event) => {
  const home_slider = $(".home-slider-wrapper");
  home_slider.slick({
    dots: true, 
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-categories"]) return;
  try {
    
  $(window).on('load', function() {
   const m_slider = $(".collection-columns");
    m_slider.slick({
      dots: false,
      infinite: false,
      speed: 800,
      slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 4000,
            settings: {
              slidesToShow: 5,
              arrows: true
            }
          },
          {
            breakpoint: 989,
            settings: {
              slidesToShow: 2,
              arrows: true
            }
          }
        ]
    }); 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page-banner"] && !window.DesignMode) return;
  try {
    
  $(window).on("load", function () {
    $(".landing-page-banner .dogn_btn a").click(function(event) {
    	event.preventDefault();
      $('html, body').animate({
          scrollTop: $(".landing-page-new-arrivals").offset().top + 100
      }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page-product-highlights"] && !window.DesignMode) return;
  try {
    
  $(window).on('DOMContentLoaded', function() {
     const m_slider = $(".product-highlight-block .product-highlights");
      m_slider.slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
          responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page-slider"] && !window.DesignMode) return;
  try {
    
  $(window).on('DOMContentLoaded', function() {
     const m_slider = $(".landing-page-slides");
      m_slider.slick({
        dots: true,
        arrows: true,
        infinite: false,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-banner"]) return;
  try {
    
  var scrolled = $(window).scrollTop();
  function resetLpBannerIcons() {
    scrolled = $(window).scrollTop();
    $('.img-parallax.stop-animation').css('transform', 'translate3d(0, ' + -(scrolled * 0.8) + 'px, 0)'); // parallax (25% scroll rate)
    $('.toon.stop-animation').css('transform', 'translate3d(0, 0, 0)'); // parallax (25% scroll rate)
  }
  function fixToonPosition() {
    var scrolled = $(this).scrollTop();
    if($(".toon-1").is(":in-viewport")) {
      $(".toon-1").css('transform', 'translate3d(0, ' + (scrolled * 0.18) + 'px, 0)'); // parallax (25% scroll rate)
    }
  if($(".toon-2").is(":in-viewport")) {
      $(".toon-2").not(".stop-animation").css('transform', 'translate3d(0, ' + (scrolled * 0.18) + 'px, 0)'); // parallax (25% scroll rate)
    }
  if($(".toon-3").is(":in-viewport")) {
      $(".toon-3").not(".stop-animation").css('transform', 'translate3d(0, ' + (scrolled * 0.12) + 'px, 0)'); // parallax (25% scroll rate)
    }
  if($(".toon-4").is(":in-viewport")) {
      $(".toon-4").not(".stop-animation").css('transform', 'translate3d(0, ' + (scrolled * 0.11) + 'px, 0)'); // parallax (25% scroll rate)
    }
  }
  $(document).on("click", "#toggle-parallax", function(){
    $(this).addClass("stopped");
    $(this).text("Play Animation");
    $(".img-parallax, .toon").addClass("stop-animation");
    resetLpBannerIcons();
  });
  $(document).on("click", "#toggle-parallax.stopped", function(){
    $(this).removeClass("stopped");
    $(this).text("Stop Animation");
    $(".img-parallax, .toon").removeClass("stop-animation");
    $(".img-parallax").removeAttr("style");
    fixToonPosition();
  });
  $(function(){
    /*$(".toon").each(function(){
      new ScrollMagic.Scene({
        duration: 2000, // the scene should last for a scroll distance of 100px
        offset: 0 // start this scene after scrolling for 50px
        })
        .setPin('.toon') // pins the element for the the scene's duration
        .addTo(controller); // assign the scene to the controller
    });*/
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	$("body").on("click", ".updateCartQuantity", function(){
		var qty = $(this).prev().val();
		var line = parseInt($(this).parent().prev().attr("for").split("-")[1]);
		var ci = new CartItems();
		ci.updateQuantity(line, qty, "plus");
	});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);
  
  
  
  
function setInventoryMsg() {
    var variant1 = "";
    $("variant-radios .product-form__input").each(function(){
    	variant1 += $(this).children("input[type='radio']:checked").val().replace(/\s/g, '').replace(/\//g, "");
    });
    var inventory = parseInt($(".variantSelector option[data-title='"+variant1+"']").data("qty"));
    $(".total_stock .qty_txt").text(inventory);
    if(inventory < 10 && inventory > 0) {
    	$(".total_stock").css({"display":"block"});
    }
    else {
    	$(".total_stock").css({"display":"none"});
    }
}  
  
$(function(){
  var count = 0;
  
  if($(".apd-acc-section").length > 0 ) {
    $(".apd-acc-section").each(function(){
      if($.trim($(this).find("h1").text().toLowerCase()) == "image with text") {
  		count = 1;
	  $(this).find("table tr").each(function(){
		var len = $(this).children("td").length;
		var html = `<div class="iwt-info">`;
		$(this).children("td").each(function(){
		if($.trim($(this).html()) != "" && $.trim($(this).html()) != "&nbsp;") {
  		var cClass = "";
  		if($(this).find("figure").length > 0) {
  			cClass = "img-col";
  		}
        else {
  			cClass = "text-col";
        }
			var tdHtml = $(this).html();
			html += `<div class="col-${len} ${cClass}">${tdHtml}</div>`;
		}
		else {
			len = len - 1;
		}
		});
		html += `</div>`;
		$(".iwt-wrapper").append(html);
	  });
		
		}
    });
	
  }
  if(count == 0) {
  	$(".iwt-image-with-text").css({"display":"none"});
  }
  
  $("body").on("click", "variant-radios input[type='radio']", function(){
    if($(this).is(":checked")) {
  		var imgName = $(this).val().toLowerCase();
        var ind = $(".productMediaListDemo li[data-alt='"+imgName+"']").index();
        if(ind > -1) {
            $(".product__media-list").slick('slickGoTo', ind);
        }
    	setInventoryMsg()
    }
  }); 
    
  
  if($(".descriptionWrap").children().length < 2) {
  	$(".descriptionWrap").css({"margin-bottom":"0px"}); 
  }
  
}); 

$(window).on("load", function(){
  var count = 0;
  setInventoryMsg();
  setInterval(function(){
    if($(".rc-container-wrapper").length > 0) {
      $(".single-product-form").addClass("rechargeWrap");
  	  $(".description_textInner").css({"display":"block"});
    }
  	
  $(".single-product-form").addClass("rechargeWrap");
  	if($(".product-form__quantity").prev("form#product-form-installment").length < 1 && $("form#product-form-installment").length > 0) {
  		if(count == 0) {
          //$(".product-form__input").insertBefore(".main-product-form");
          $(".product-form__quantity").insertBefore(".product-form__buttons");
          //$("form#product-form-installment").insertBefore(".main-product-form");
          //$(".description_text").insertBefore("form#product-form-installment");
  		  count = 1;
  		  
  		  $(".customRecharge").addClass("loaded");
  		}
	}
  }, 500);
  
  var checkReivewsInterval;
  function checkReivews() {
  	if($(".bv-content-secondary-ratings-value").length > 0) {
  		$(".bv-content-secondary-ratings-value").each(function(){
  			var reviewVal = $(this).attr("class").split(" ")[1].split('-').pop();
  			$(this).css({"display":"none"});
  			var rCss = "background-size: "+reviewVal+"% 100%!important";
  			$(this).attr("style", rCss);
  			//$(this).css({"background-size": reviewVal+"% 100%!important"});
  		});
  		//clearInterval( checkReivewsInterval );
  	}
  }
  checkReivewsInterval = setInterval(checkReivews, 2000);
  
  
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"]) return;
  try {
    
$(window).on("load resize", function(){
	if($(window).width() < 750) {
		$(".inline-review-stars").insertAfter(".productTitleWrap");
	}
	else {
		if($(".product__info-container .inline-review-stars").length < 1) {
			$(".inline-review-stars").prependTo(".product__info-container");
		}
	}
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-horizon-slides"] && !window.DesignMode) return;
  try {
    
  window.addEventListener("DOMContentLoaded", ()=>{
    $(window).on('load', function() {
      if ($(window).width() < 768) {
       const mob_slider = $(".vertical-slider-main");
        mob_slider.slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 800,
          fade: true,
          slidesToShow: 1,
          slidesToScroll: 1
        });
        /*mob_slider.on('wheel', (function (e) {
          e.preventDefault();
          if (e.originalEvent.deltaY < 0) {
            $(this).slick('slickPrev');
          } else {
            $(this).slick('slickNext');
          }
        }));*/
      }else{
        const slider = $(".vertical-slider-main");
        slider.slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 1200,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: true,
          verticalSwiping: true,
        });
        slider.on('wheel', (function (e) {
          e.preventDefault();
          if (e.originalEvent.deltaY < 0) {
            $(this).slick('slickPrev');
          } else {
            $(this).slick('slickNext');
          }
        }));
      }
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tags-information"]) return;
  try {
    
  $(function(){
  	if($(".tag-box").length < 1) {
  		$(".tag-section").css({"display":"none"});
  	}
  	else {
        var curTag = $(".tag-box.active").data("tag");
        $(".tag-content."+curTag).addClass("active");
        $("body").on("mouseenter focus", ".tag-box", function(){
            var _this = $(this);
            $(".tag-box").removeClass("active");
            $(this).addClass("active");
            $(".tag-content").removeClass("active");
            $(".tag-content."+$(this).data('tag')).addClass("active");
            var ind = $(this).data("seq");
            if($(window).width() < 750 ) {
                if(ind % 2 == 0) {
                    $(".tags-content").insertAfter($(this));
                }
                else {
                    $(".tags-content").insertAfter($(this).next());
                }
            }
        });
  	}
  });

  $(window).on("load resize", function(){
    if($(window).width() < 750 ) {
  	if($(".tags-block-wrap >.tags-content").length > 0) {
  		var ind = $(".tag-box.active").data("seq");
  		console.log(ind);
  		if(ind % 2 == 0) {
  			$(".tags-content").insertAfter(".tag-box-"+ind);
  		}
  		else {
  			if($(".tag-box-"+(ind + 1)).length > 0) {
  				$(".tags-content").insertAfter(".tag-box-"+(ind + 1));
  			}
  			else {
  				$(".tags-content").insertAfter(".tag-box-"+ind);
  			}

  		}
  	}
    }
    else {
      if($(".tags-boxes >.tags-content").length > 0) {
  		$(".tags-content").insertAfter(".tags-boxes");
  	}
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["womenshealth-banner"] && !window.DesignMode) return;
  try {
    
$(window).on("load", function () {
  $(".womenshealth-banner .dogn_btn a").click(function(event) {
  	event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".womenshealth-new-arrivals").offset().top + 100 
    }, 500);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["womenshealth-new-arrivals"] && !window.DesignMode) return;
  try {
    
$(window).on('load', function() {
   const m_slider = $(".bsc-main .womenshealth-product-block");
    m_slider.slick({
      dots: false,
      arrows: true, 
      infinite: false,
      speed: 800,
      slidesToShow: 4,
      slidesToScroll: 1,
        responsive: [
      {
        breakpoint: 1025, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    }); 
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["womenshealth-slider"] && !window.DesignMode) return;
  try {
    

$(window).on('load', function() {
   const m_slider = $(".womenshealth-slider-main");
    m_slider.slick({
      dots: true,
      arrows: true, 
      infinite: false,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1
    });
}); 
  


  } catch(e) { console.error(e); }
})();
})();
